import "./EditIOProperties.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditIOPropertiesComponentController from "./EditIOPropertiesComponentController";

export class EditIOPropertiesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditIOPropertiesComponentController;
        this.templateUrl =
            "/App/Components/EquipmentFunctionalityType/IOProperties/EditIOProperties/EditIOProperties.html";
    }
}

module("mmManagePortal").component("irEditFunctionalityIoProperties", new EditIOPropertiesComponent());
